import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {Link} from 'gatsby';

function Laverage(props) {
    return (
        <div className="laverage_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={12} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Our Well-structured App Development Process to Craft Innovative Mobile Applications</h2>
                        <p>TekRevol believes in the true pattern of working on a project to ensure the optimal result so that any business can capitalize on its mobile app solution. Our app developers in Qatar are experts in crafting mobile applications with advanced technologies and frameworks while maintaining the workflow through the agile approach. The exceptional quality stems from the additional dedication invested in each project. Explore our organized process tailored for any project.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
                        <div className="process_listing">
                            <div className="process_item">
                                <div className="number">01</div>
                                <h6>Ideation</h6>
                                <p>Conducting Product Discovery and Product Research.</p>
                            </div>
                            <div className="process_item">
                                <div className="number">02</div>
                                <h6>Design</h6>
                                <p>Creating the UX Design, UI Design, and Branding</p>
                            </div>
                            <div className="process_item">
                                <div className="number">03</div>
                                <h6>Development</h6>
                                <p>Coding the app courtesy of our veteran engineers</p>
                            </div>
                            <div className="process_item">
                                <div className="number">04</div>
                                <h6>Quality Assurance</h6>
                                <p>Testing the app and making sure that everything works well</p>
                            </div>
                            <div className="process_item">
                                <div className="number">05</div>
                                <h6>Maintenance & Support</h6>
                                <p>Co-managing the app with your technology team.</p>
                            </div>

                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Laverage;